import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import ContactForm from './ContactForm'

function ContactUs() {
  return (
    <Box
      component="section"
      id="contact_us"
      sx={{
        mt: 6,
        backgroundImage: "url('images/sections/contact_us.png')",
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >
      <Grid container
        id="contact"
        sx={{mt:6, p:8, position:'relative', zIndex:'10'}}
        spacing={{ xs: 2, md: 3, lg: 8 }}
      >
        <Grid item xs={12} md={6} lg={4}>
          <ContactForm title='Contactar'/>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Typography variant='h4'>
          Solicita nuestros servicios
          </Typography>
          <Typography variant='h2'>
          ¡Contáctanos!
          </Typography>
          {/* <Typography variant='body1'>
          Horario de atención: xx-xx
          </Typography> */}
        </Grid>
      </Grid>
    </Box>
  )
}

export default ContactUs